export const ConnectorMenuList = [
    // {
    //     title: "Dashboard",
    //     iconStyle: imagepaths.DashboardWhiteIcon,
    //     iconActive: imagepaths.DashboardWhiteIconActive,
    //     to: "/app/connectorhome",
    //     id: "connectorhome",
    // },
    {
        title: "My Profile",
        iconStyle: imagepaths.ProfileWhite,
        iconActive: imagepaths.ProfileWhiteActive,
        to: "/app/myprofile",
        id: "myprofile",
    },
    {
        title: "My Earnings",
        iconStyle: imagepaths.WalletIconWhite,
        iconActive: imagepaths.WalletIconWhiteActive,
        to: "/app/myearnings",
        id: "myearnings",
    },
    {
        title: "My leads",
        iconStyle: imagepaths.ProfileWhite,
        iconActive: imagepaths.ProfileWhiteActive,
        to: "/app/enquiries",
        id: "enquiries",
    },
    {
        title: "Policies",
        iconStyle: imagepaths.shieldIconWhite,
        iconActive: imagepaths.shieldIconWhiteActive,
        to: "/app/connectorhome",
        id: ["dataPrivacyModal", "dataStorageModal", "rbipolicy"],
        classChange: "mm-collapse",
        content: [
            {
                title: "Privacy Policy",
                iconStyle: imagepaths.PrivacyPolicyWhite,
                iconActive: imagepaths.PrivacyPolicyWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataPrivacyModal",
                showTitle: true
            },
            {
                title: "Terms and Conditions",
                iconStyle: imagepaths.MasterDataIconWhite,
                iconActive: imagepaths.MasterDataIconWhiteActive,
                to: "/app/connectorhome",
                classChange: "menu-popup",
                id: "dataStorageModal",
            }
        ],
    },
];
